// colors are were plum_1

const eventTypes = {
	name: "Events",
	id: "events",
	parent: "self",
	color: {
		colorblind: false,
		dark: "#92278f", // plum_1
		light: "#92278f",
	},
	children: [
		{
			name: "ANSF Ops",
			id: "ansf_ops",
			parent: "events",
			color: {
				dark: "#c1c161", // drab
				light: "#c1c161",
				colorblind: "colorblindGaps",
			},
		},
		{
			name: "BBIED",
			id: "bbied",
			parent: "events",
			color: {
				dark: "#CEBF09", // Goldenrod
				light: "#1cce99", // "#7CBD1E"; // green
				colorblind: "colorblindSmall",
			},
		},
		{
			name: "Demonstration",
			id: "demonstration",
			parent: "events",
			color: {
				dark: "#F0FCAC", // pale green
				light: "#fddf6b", // yellow
				colorblind: "colorblindBig",
			},
		},
		{
			name: "Heavy Weapons",
			id: "heavy_weapons",
			parent: "events",
			color: {
				dark: "#C2EB3C", // chartreuse
				light: "#c2eb3c", // '#8deb3c'; // chartreuse
				colorblind: "colorblindStripes",
			},
		},
		{
			name: "IED",
			id: "ied",
			parent: "events",
			color: {
				dark: "#32C402", // grass
				light: "#1cce99", // "#7CBD1E"; // green
				colorblind: "colorblindTinyDots",
			},
		},
		{
			name: "IDF",
			id: "idf",
			parent: "events",
			color: {
				dark: "#1cce99", // green
				light: "#1cce99", // green
				colorblind: "colorblindDots",
			},
		},
		{
			name: "Kidnapping",
			id: "kidnapping",
			parent: "events",
			color: {
				dark: "#b3f3fc", // off white
				light: "#fddf6b", // yellow
				colorblind: false,
			},
		},
		{
			name: "Small Arms",
			id: "small_arms",
			parent: "events",
			color: {
				dark: "#66a4ff", // Light Blue
				light: "#66a4ff", // "#00BBF0"; // cerulean
				colorblind: "colorblindBroken",
			},
		},
		{
			name: "VBIED",
			id: "vbied",
			parent: "events",
			color: {
				dark: "#0074E4", // blue
				light: "#0074E4", // blue
				colorblind: "colorblindDashed",
			},
		},
		{
			name: "Other",
			id: "other",
			parent: "events",
			color: {
				dark: "#2e42ff", // royal blue
				light: "#2e42ff",
				colorblind: "colorblindTiny",
			},
		},
	],
};

export default eventTypes;
